import ApiClient from "./api-client";
import type { BuildQuestionValues } from "@live-writing/models";

class TeacherService {
  public static async startChatClarifyJob(
    preLessonId: number,
    message: string,
    previousResponseId?: string,
    questionItem?: BuildQuestionValues,
  ): Promise<{ response_id: string; status: string }> {
    const body: {
      message: string;
      previous_response_id?: string;
      question?: BuildQuestionValues;
    } = { message };
    if (previousResponseId) body.previous_response_id = previousResponseId;
    if (questionItem) body.question = questionItem;

    const response = await ApiClient.post<{
      response_id: string;
      status: string;
    }>(`/pre-lesson/${preLessonId}/clarify-teacher`, body);
    return response;
  }

  public static async pollChatClarifyJob(
    responseId: string,
  ): Promise<{ status: string; response?: string; error?: string }> {
    const response = await ApiClient.get<{
      status: string;
      response?: string;
      error?: string;
    }>(`/pre-lesson/clarify-teacher-status/${responseId}`);
    return response;
  }

  public static async buildFromStudentSubmissions(
    preLessonId: number,
  ): Promise<{ questions: { question: string; points: string[] }[] }> {
    const response = await ApiClient.post<{
      questions: { question: string; points: string[] }[];
    }>(`/pre-lesson/${preLessonId}/generate-questions`, {});
    return response;
  }

  public static async startGenerateQuestionsJob(
    preLessonId: number,
  ): Promise<{ response_id: string; status: string }> {
    const response = await ApiClient.post<{
      response_id: string;
      status: string;
    }>(`/pre-lesson/${preLessonId}/generate-questions`, {});
    return response;
  }

  public static async pollGenerateQuestionsJob(
    responseId: string,
    preLessonId?: number,
  ): Promise<{
    status: string;
    questions?: { question: string; points: string[] }[];
    error?: string;
  }> {
    const url = `/pre-lesson/generate-questions-status/${responseId}${preLessonId ? `?pre_lesson_id=${preLessonId}` : ""}`;
    const response = await ApiClient.get<{
      status: string;
      questions?: { question: string; points: string[] }[];
      error?: string;
    }>(url);
    return response;
  }
}

export default TeacherService;
